import { render } from "./Work.vue?vue&type=template&id=713d9eb8"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elschubi/_development/_vue/projects/faszl-gfk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__